import React from 'react';
import { getRouteUrl } from '@css-xp/ppc-utils';
import { routePaths } from '@css-xp/ppc-constants';
import { Maybe, TransactionAccountProduct } from '@css-xp/graphtypes/src/generated-types-new';
import { SubscriptionWidgetItem, SubscriptionWidgetTable } from '../../widget';

type Subscriptions = Maybe<
  | Array<
      Maybe<
        Pick<
          TransactionAccountProduct,
          | 'id'
          | 'logoId'
          | 'transactionAccountId'
          | 'entitlementNumber'
          | 'createdDate'
          | 'productName'
          | 'productId'
          | 'cloudSiteId'
          | 'cloudSiteHostname'
          | 'offering'
        >
      >
    >
  | undefined
>;

export const getSubscriptionCreatedWidgetContent = (
  subscriptions: Subscriptions,
  heading?: string,
  version?: number
) => {
  if (!subscriptions || !subscriptions.length) {
    return null;
  }

  if (version === 2) {
    return <SubscriptionWidgetTable subscriptions={subscriptions} heading={heading} />;
  }

  return subscriptions.map((subscription, index) => {
    if (!subscription || !subscription.transactionAccountId) {
      return null;
    }
    const URL = getRouteUrl(routePaths.entitlement, {
      txaId: subscription.transactionAccountId,
      entitlementId: subscription.id,
    });

    return (
      <SubscriptionWidgetItem
        timestamp={subscription.createdDate}
        url={URL}
        key={index}
        {...subscription}
        heading={heading}
      />
    );
  });
};
